import css from './index.module.scss';
import { useGlobal } from '@/utils/useGlobal';
import { createEFPic } from '@/utils/useEFPic';

const { EFPic } = createEFPic('');

export default function P() {
    const { useLang, useRouter } = useGlobal();
    const { t } = useLang('productriver2.river2.details');
    const { locale } = useRouter();
    return (
        <div className={`${css.P_16} river2_detials_p`}>
            <div className="container">
                <div className="title-wrapper">
                    <div className="title">{t('sec16_title')}</div>
                    <div className="img-wrapper">
                        <EFPic
                            name={
                                locale === 'za'
                                    ? 'https://ecoflow-service-us-cdn.ecoflow.com/configurable/images/1711679893590/r2p_p1_1_1366_za.jpg'
                                    : '/media/river2/pc/P1_river2_1.png'
                            }
                            className="fullImgs"
                            alt={t('sec16_title')}
                            aria-label={t('sec16_title')}
                        />
                    </div>
                </div>
                <div className="content-wrapper">
                    <div className="description">
                        {t.rich('sec16_desc', {
                            p1: (h: string) => <span className="white">{h}</span>,
                        })}
                    </div>
                    <div className="content">
                        <div className="item">
                            <div className="img-wrap">
                                <EFPic
                                    name={'/media/river2/pc/P1_river2_2.png'}
                                    className="fullImgs"
                                    alt={t('sec16_item_1_title')}
                                    aria-label={t('sec16_item_1_title')}
                                />
                            </div>
                            <div className="item-content">
                                <div className="item-title">{t('sec16_item_1_title')}</div>
                                <div className="item-desc">{t('sec16_item_1_desc')}</div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img-wrap">
                                <EFPic
                                    name={'/media/river2/pc/P1_river2_3.png'}
                                    className="fullImgs"
                                    alt={t('sec16_item_2_title')}
                                    aria-label={t('sec16_item_2_title')}
                                />
                            </div>
                            <div className="item-content">
                                <div className="item-title">{t('sec16_item_2_title')}</div>
                                <div className="item-desc">{t('sec16_item_2_desc')}</div>
                            </div>
                        </div>
                        <div className="item">
                            <div className="img-wrap">
                                <EFPic
                                    name={'/media/river2/pc/P1_river2_4.png'}
                                    className="fullImgs"
                                    alt={t('sec16_item_3_title')}
                                    aria-label={t('sec16_item_3_title')}
                                />
                            </div>
                            <div className="item-content">
                                <div className="item-title">{t('sec16_item_3_title')}</div>
                                <div className="item-desc">{t('sec16_item_3_desc')}</div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}
